var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFinishTrainingGuide = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 310,
    viewBox: "0 0 332 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_5929)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 86.6744,
    y: 108.675,
    width: 162.651,
    height: 163.735,
    rx: 75,
    fill: "#FAB8B8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 103.909,
    y: 126.024,
    width: 128.182,
    height: 129.036,
    rx: 64.0908,
    fill: "#FAB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.276 240.964H156.808C137.367 240.964 121.606 224.898 121.606 205.082V175.181C121.606 155.365 137.367 139.299 156.808 139.299H180.276C199.716 139.299 215.478 155.365 215.478 175.181V205.082C215.478 224.898 199.716 240.964 180.276 240.964Z",
    fill: "#AF0713"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.276 233.144H156.808C137.367 233.144 121.606 217.386 121.606 197.952V174.491C121.606 155.056 137.367 139.299 156.808 139.299H180.276C199.716 139.299 215.478 155.056 215.478 174.491V197.952C215.478 217.386 199.716 233.144 180.276 233.144Z",
    fill: "#DA0C17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.654 223.368H153.43C143.417 223.368 135.295 215.145 135.295 205.007V177.466C135.295 163.946 146.122 152.985 159.475 152.985H177.609C190.962 152.985 201.789 163.946 201.789 177.466V205.007C201.789 215.145 193.667 223.368 183.654 223.368Z",
    fill: "#D3D0CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.654 223.368H153.43C143.417 223.368 135.295 215.249 135.295 205.239V181.067C135.295 167.718 146.122 156.895 159.475 156.895H177.609C190.962 156.895 201.789 167.718 201.789 181.067V205.239C201.789 215.249 193.667 223.368 183.654 223.368Z",
    fill: "#E7E4E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.874 180.356C150.096 180.356 147.029 183.422 147.029 187.199C147.029 190.976 150.096 185.367 153.874 185.367C157.653 185.367 160.719 190.976 160.719 187.199C160.719 183.422 157.653 180.356 153.874 180.356Z",
    fill: "#302C2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.21 180.356C179.431 180.356 176.365 183.422 176.365 187.199C176.365 190.976 179.431 185.367 183.21 185.367C186.988 185.367 190.055 190.976 190.055 187.199C190.055 183.422 186.988 180.356 183.21 180.356Z",
    fill: "#302C2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.498 197.952C170.498 196.873 169.186 195.997 167.564 195.997C165.942 195.997 164.63 196.873 164.63 197.952C164.63 199.031 165.942 199.907 167.564 199.907C169.186 199.907 170.498 199.031 170.498 197.952Z",
    fill: "#302C2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.542 217.503C159.899 217.503 152.896 210.949 152.896 202.867C152.896 202.123 153.738 201.635 154.452 201.97L155.444 202.435C158.341 203.788 161.536 204.494 164.775 204.494H168.542H172.309C175.548 204.494 178.743 203.788 181.64 202.435L182.632 201.97C183.346 201.635 184.187 202.123 184.187 202.867C184.187 210.949 177.184 217.503 168.542 217.503Z",
    fill: "#302C2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.478 203.817C211.157 203.817 207.656 200.098 207.656 195.508V178.89C207.656 174.3 211.157 170.581 215.478 170.581C219.8 170.581 223.301 174.3 223.301 178.89V195.508C223.301 200.098 219.8 203.817 215.478 203.817Z",
    fill: "#A26C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.478 199.907C211.157 199.907 207.656 196.261 207.656 191.761V178.727C207.656 174.227 211.157 170.581 215.478 170.581C219.8 170.581 223.301 174.227 223.301 178.727V191.761C223.301 196.261 219.8 199.907 215.478 199.907Z",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.606 199.907C117.284 199.907 113.783 196.261 113.783 191.761V178.727C113.783 174.227 117.284 170.581 121.606 170.581C125.927 170.581 129.428 174.227 129.428 178.727V191.761C129.428 196.261 125.927 199.907 121.606 199.907Z",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.763,
    y: 135.389,
    width: 19.5568,
    height: 7.82037,
    rx: 3.6,
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.586 135.389H170.498V121.703H166.586V135.389Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.542 123.658C165.303 123.658 162.675 121.031 162.675 117.793C162.675 114.555 165.303 111.928 168.542 111.928C171.781 111.928 174.409 114.555 174.409 117.793C174.409 121.031 171.781 123.658 168.542 123.658Z",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.397 117.898L124.315 128.791",
    stroke: "#AB0009",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.812 127.493L112.062 136.382",
    stroke: "#AB0009",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6936 145.946L106.038 149.011",
    stroke: "#AB0009",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.857 117.898L212.938 128.791",
    stroke: "#AB0009",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.441 127.493L225.191 136.382",
    stroke: "#AB0009",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.56 145.946L231.215 149.011",
    stroke: "#AB0009",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.614 219.277C111.614 215.686 108.7 212.771 105.108 212.771C101.517 212.771 98.6022 215.686 98.6022 219.277C98.6022 222.868 101.517 225.783 105.108 225.783C108.7 225.783 111.614 222.868 111.614 219.277Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.108 178.072C105.108 175.678 103.165 173.735 100.771 173.735C98.3766 173.735 96.4335 175.678 96.4335 178.072C96.4335 180.467 98.3766 182.41 100.771 182.41C103.165 182.41 105.108 180.467 105.108 178.072Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.277 247.47L118.12 237.711",
    stroke: "#FF5D65",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6744 197.59L98.6021 195.422",
    stroke: "#FF5D65",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.385 219.277C224.385 215.686 227.3 212.771 230.891 212.771C234.483 212.771 237.397 215.686 237.397 219.277C237.397 222.868 234.483 225.783 230.891 225.783C227.3 225.783 224.385 222.868 224.385 219.277Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.891 178.072C230.891 175.678 232.834 173.735 235.229 173.735C237.623 173.735 239.566 175.678 239.566 178.072C239.566 180.467 237.623 182.41 235.229 182.41C232.834 182.41 230.891 180.467 230.891 178.072Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.723 247.47L217.879 237.711",
    stroke: "#FF5D65",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.325 197.59L237.397 195.422",
    stroke: "#FF5D65",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1095 257.026C84.462 255.347 82.982 253.339 80.9757 251.209C78.9955 249.105 76.6106 246.993 74.2929 245.103C71.9791 243.215 69.7549 241.567 68.1079 240.389C67.2851 239.801 66.6079 239.331 66.1378 239.01C66.1059 238.988 66.075 238.967 66.045 238.946L65.3177 239.224C65.3093 239.258 65.3006 239.294 65.2918 239.33C65.1572 239.882 64.9676 240.683 64.7492 241.668C64.3119 243.641 63.761 246.349 63.304 249.294C62.8462 252.244 62.4874 255.404 62.4253 258.287C62.3624 261.208 62.6098 263.687 63.2577 265.367C64.6846 269.067 67.0372 271.256 69.6749 272.286C72.3405 273.326 75.437 273.237 78.3954 272.107C81.3371 270.983 83.6825 268.946 84.9589 266.368C86.2239 263.812 86.4942 260.617 85.1095 257.026Z",
    fill: "#F2DD9D",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.35 257.026C43.9976 255.347 45.4776 253.339 47.4839 251.209C49.4641 249.105 51.849 246.993 54.1667 245.103C56.4805 243.215 58.7046 241.567 60.3517 240.389C61.1745 239.801 61.8516 239.331 62.3218 239.01C62.3537 238.988 62.3846 238.967 62.4146 238.946L63.1419 239.224C63.1503 239.258 63.1589 239.294 63.1678 239.33C63.3024 239.882 63.492 240.683 63.7104 241.668C64.1477 243.641 64.6986 246.349 65.1556 249.294C65.6134 252.244 65.9722 255.404 66.0343 258.287C66.0972 261.208 65.8498 263.687 65.2019 265.367C63.775 269.067 61.4224 271.256 58.7847 272.286C56.1191 273.326 53.0226 273.237 50.0641 272.107C47.1225 270.983 44.7771 268.946 43.5007 266.368C42.2357 263.812 41.9654 260.617 43.35 257.026Z",
    fill: "#F2DD9D",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5444 236.241L62.5452 236.24C62.7634 235.928 62.8275 235.611 62.8504 235.424C62.9314 234.763 63.1538 234.239 63.3755 233.975C63.4746 233.857 63.5333 233.838 63.5336 233.838C63.5343 233.837 63.5372 233.836 63.5489 233.836C63.5619 233.836 63.5998 233.839 63.6674 233.861C63.6674 233.861 63.6674 233.861 63.6674 233.861L63.7545 233.89C64.0624 233.993 64.3953 233.993 64.7032 233.89L64.7835 233.864C64.8513 233.841 64.8885 233.839 64.9001 233.839C64.9065 233.839 64.9093 233.839 64.9096 233.839L64.9107 233.839C64.9112 233.84 64.9241 233.844 64.9498 233.863C64.9766 233.882 65.0167 233.917 65.0662 233.977C65.291 234.246 65.5169 234.779 65.6108 235.455C65.6366 235.64 65.7043 235.943 65.9135 236.241C69.9294 241.972 72.9724 247.119 75.0061 251.549C77.0515 256.006 78.0223 259.622 78.0223 262.326C78.0223 267.007 76.3725 270.413 73.9041 272.66C71.4132 274.927 67.9697 276.12 64.2288 276.12C60.5062 276.12 57.0604 274.874 54.5603 272.571C52.0794 270.285 50.4354 266.872 50.4354 262.326C50.4354 259.52 51.4083 255.903 53.451 251.478C55.484 247.074 58.5265 241.977 62.5444 236.241Z",
    fill: "#F2DD9D",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.055 263.054C70.055 263.054 67.7805 265.956 64.2289 265.967C60.7356 265.967 58.4028 263.054 58.4028 263.054",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1311,
    cy: 257.228,
    r: 1.91667,
    fill: "#262222",
    stroke: "#262222",
    strokeWidth: 0.536231
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-36-inside-1_140_5929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.3268,
    cy: 257.228,
    rx: 2.18478,
    ry: 2.18478
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.3268,
    cy: 257.228,
    rx: 2.18478,
    ry: 2.18478,
    fill: "#262222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6782 257.228C67.6782 256.318 68.4163 255.58 69.3268 255.58V263.246C72.6505 263.246 75.3449 260.552 75.3449 257.228H67.6782ZM69.3268 255.58C70.2372 255.58 70.9753 256.318 70.9753 257.228H63.3086C63.3086 260.552 66.003 263.246 69.3268 263.246V255.58ZM70.9753 257.228C70.9753 258.139 70.2372 258.877 69.3268 258.877V251.21C66.003 251.21 63.3086 253.905 63.3086 257.228H70.9753ZM69.3268 258.877C68.4163 258.877 67.6782 258.139 67.6782 257.228H75.3449C75.3449 253.905 72.6505 251.21 69.3268 251.21V258.877Z",
    fill: "#262222",
    mask: "url(#path-36-inside-1_140_5929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8476 136.957C72.8476 150.571 60.5323 161.87 44.9998 161.87C29.4673 161.87 17.152 150.571 17.152 136.957C17.152 123.342 29.4673 112.043 44.9998 112.043C60.5323 112.043 72.8476 123.342 72.8476 136.957Z",
    fill: "#FF5D65",
    stroke: "#262222",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6303 136.957C37.6303 138.289 36.5499 139.37 35.2172 139.37C33.8846 139.37 32.8042 138.289 32.8042 136.957C32.8042 135.624 33.8846 134.543 35.2172 134.543C36.5499 134.543 37.6303 135.624 37.6303 136.957Z",
    fill: "#262222",
    stroke: "#262222",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.7824,
    cy: 136.956,
    r: 2.41304,
    fill: "#262222",
    stroke: "#262222",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7824 145.761C54.7824 145.761 50.9632 151.607 44.9998 151.63C39.1342 151.63 35.2172 145.761 35.2172 145.761",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7295 116.445L30.1343 123.881L41.2197 120.011L44.9998 131.25L48.8026 120.011L60.0768 123.881L54.5492 116.445L63.8268 114.375C63.8268 114.375 56.6063 110.631 52.6742 110.625C48.7422 110.619 44.9998 112.472 44.9998 112.472L46.8748 105L45.0819 104.111L43.0947 103.125L44.9697 112.472C44.9697 112.472 42.0197 110.618 37.4998 110.625C32.9798 110.632 26.3843 114.375 26.3843 114.375L35.7295 116.445Z",
    fill: "#318C35",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-2_140_5929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.806 35.7983L157.833 20.4166L129.083 69.7023C129.083 69.7023 143.458 77.9166 157.833 77.9166C172.208 77.9166 186.583 69.7023 186.583 69.7023L170.41 41.9775C169.708 42.8548 168.628 43.4166 167.416 43.4166C165.299 43.4166 163.583 41.7004 163.583 39.5833C163.583 37.674 164.979 36.0908 166.806 35.7983Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.806 35.7983L157.833 20.4166L129.083 69.7023C129.083 69.7023 143.458 77.9166 157.833 77.9166C172.208 77.9166 186.583 69.7023 186.583 69.7023L170.41 41.9775C169.708 42.8548 168.628 43.4166 167.416 43.4166C165.299 43.4166 163.583 41.7004 163.583 39.5833C163.583 37.674 164.979 36.0908 166.806 35.7983Z",
    fill: "#F28A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.833 20.4166L160.424 18.905C159.887 17.9834 158.9 17.4166 157.833 17.4166C156.766 17.4166 155.779 17.9834 155.242 18.905L157.833 20.4166ZM166.806 35.7983L167.28 38.7606C168.257 38.6042 169.094 37.976 169.517 37.0816C169.941 36.1871 169.896 35.1415 169.397 34.2867L166.806 35.7983ZM129.083 69.7023L126.492 68.1907C126.089 68.882 125.978 69.7057 126.185 70.4788C126.392 71.2518 126.9 71.91 127.595 72.3071L129.083 69.7023ZM186.583 69.7023L188.072 72.3071C188.766 71.91 189.274 71.2518 189.481 70.4788C189.688 69.7057 189.578 68.882 189.174 68.1907L186.583 69.7023ZM170.41 41.9775L173.002 40.4659C172.504 39.612 171.617 39.0583 170.631 38.9856C169.645 38.913 168.686 39.3307 168.069 40.1024L170.41 41.9775ZM155.242 21.9282L164.214 37.3099L169.397 34.2867L160.424 18.905L155.242 21.9282ZM131.674 71.214L160.424 21.9282L155.242 18.905L126.492 68.1907L131.674 71.214ZM157.833 74.9166C151.164 74.9166 144.366 72.9987 139.135 71.006C136.541 70.0178 134.38 69.0296 132.873 68.2916C132.121 67.9231 131.534 67.618 131.141 67.4082C130.944 67.3034 130.796 67.2224 130.7 67.1693C130.652 67.1427 130.617 67.1231 130.595 67.111C130.585 67.105 130.577 67.1008 130.573 67.0985C130.571 67.0974 130.57 67.0967 130.57 67.0966C130.57 67.0965 130.57 67.0966 130.57 67.0967C130.57 67.0968 130.571 67.097 130.571 67.0971C130.571 67.0973 130.572 67.0976 129.083 69.7023C127.595 72.3071 127.595 72.3074 127.596 72.3078C127.596 72.308 127.597 72.3084 127.598 72.3087C127.599 72.3094 127.6 72.3102 127.602 72.3111C127.605 72.3129 127.609 72.3152 127.614 72.3181C127.624 72.3237 127.637 72.3313 127.654 72.3408C127.688 72.3598 127.736 72.3863 127.796 72.4199C127.918 72.4871 128.093 72.5826 128.317 72.7024C128.766 72.9418 129.414 73.2785 130.234 73.68C131.872 74.4822 134.203 75.5476 137 76.6129C142.55 78.7274 150.127 80.9166 157.833 80.9166V74.9166ZM186.583 69.7023C185.095 67.0976 185.095 67.0973 185.096 67.0971C185.096 67.097 185.096 67.0968 185.096 67.0967C185.097 67.0966 185.097 67.0965 185.096 67.0966C185.096 67.0967 185.095 67.0974 185.093 67.0985C185.089 67.1008 185.082 67.105 185.071 67.111C185.049 67.1231 185.014 67.1427 184.966 67.1693C184.87 67.2224 184.722 67.3034 184.526 67.4082C184.132 67.618 183.545 67.9231 182.793 68.2916C181.286 69.0296 179.125 70.0178 176.531 71.006C171.3 72.9987 164.502 74.9166 157.833 74.9166V80.9166C165.539 80.9166 173.116 78.7274 178.667 76.6129C181.463 75.5476 183.794 74.4822 185.432 73.68C186.252 73.2785 186.9 72.9418 187.349 72.7024C187.574 72.5826 187.748 72.4871 187.87 72.4199C187.931 72.3863 187.978 72.3598 188.012 72.3408C188.029 72.3313 188.042 72.3237 188.052 72.3181C188.057 72.3152 188.061 72.3129 188.065 72.3111C188.066 72.3102 188.068 72.3094 188.069 72.3087C188.069 72.3084 188.07 72.308 188.07 72.3078C188.071 72.3074 188.072 72.3071 186.583 69.7023ZM167.819 43.4891L183.992 71.214L189.174 68.1907L173.002 40.4659L167.819 43.4891ZM168.069 40.1024C167.911 40.2992 167.678 40.4166 167.416 40.4166V46.4166C169.577 46.4166 171.505 45.4104 172.752 43.8527L168.069 40.1024ZM167.416 40.4166C166.956 40.4166 166.583 40.0435 166.583 39.5833H160.583C160.583 43.3572 163.643 46.4166 167.416 46.4166V40.4166ZM166.583 39.5833C166.583 39.1711 166.885 38.8238 167.28 38.7606L166.332 32.8361C163.073 33.3578 160.583 36.177 160.583 39.5833H166.583Z",
    fill: "#262222",
    mask: "url(#path-43-inside-2_140_5929)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-45-inside-3_140_5929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.061 24.25L157.833 21H148.25L132.766 47.8565C133.441 48.3826 133.875 49.2031 133.875 50.125C133.875 51.7128 132.588 53 131 53C130.618 53 130.254 52.9257 129.921 52.7909L120 70H133L160.061 24.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.061 24.25L157.833 21H148.25L132.766 47.8565C133.441 48.3826 133.875 49.2031 133.875 50.125C133.875 51.7128 132.588 53 131 53C130.618 53 130.254 52.9257 129.921 52.7909L120 70H133L160.061 24.25Z",
    fill: "#F28A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.833 21L160.308 19.3038L159.414 18H157.833V21ZM160.061 24.25L162.643 25.7773L163.617 24.1313L162.535 22.5538L160.061 24.25ZM148.25 21V18H146.516L145.651 19.5016L148.25 21ZM132.766 47.8565L130.167 46.3581L128.864 48.6181L130.921 50.2222L132.766 47.8565ZM129.921 52.7909L131.047 50.0102L128.627 49.0301L127.322 51.2925L129.921 52.7909ZM120 70L117.401 68.5016L114.807 73H120V70ZM133 70V73H134.711L135.582 71.5273L133 70ZM155.359 22.6962L157.586 25.9462L162.535 22.5538L160.308 19.3038L155.359 22.6962ZM148.25 24H157.833V18H148.25V24ZM135.365 49.3549L150.849 22.4984L145.651 19.5016L130.167 46.3581L135.365 49.3549ZM130.921 50.2222C130.909 50.2128 130.898 50.2002 130.889 50.1826C130.879 50.1619 130.875 50.1396 130.875 50.125H136.875C136.875 48.2396 135.983 46.5608 134.611 45.4907L130.921 50.2222ZM130.875 50.125C130.875 50.056 130.931 50 131 50V56C134.244 56 136.875 53.3697 136.875 50.125H130.875ZM131 50C131.004 50 131.012 50.0005 131.021 50.0023C131.03 50.004 131.039 50.0067 131.047 50.0102L128.795 55.5716C129.48 55.8488 130.226 56 131 56V50ZM122.599 71.4984L132.52 54.2893L127.322 51.2925L117.401 68.5016L122.599 71.4984ZM133 67H120V73H133V67ZM157.479 22.7227L130.418 68.4727L135.582 71.5273L162.643 25.7773L157.479 22.7227Z",
    fill: "#262222",
    mask: "url(#path-45-inside-3_140_5929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.779 71.3007L134.358 71.6563L148.363 76.3345C139.553 75.8937 130.919 73.6835 122.978 69.8333H132.294L133.779 71.3007Z",
    fill: "#262222",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 64C168 64 164.096 67.9839 158 68C152.004 68 148 64 148 64",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 57L151 53L154 57",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 57L165 53L168 57",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.642 98.5914C255.325 98.5375 254.998 98.5873 254.711 98.7333L254.711 98.7336L254.692 98.7428C254.674 98.7517 254.645 98.766 254.604 98.7851C254.524 98.8232 254.401 98.88 254.243 98.9493C253.924 99.0881 253.465 99.2752 252.913 99.4624C251.79 99.8432 250.368 100.196 249.001 100.196C247.634 100.196 246.212 99.8432 245.089 99.4624C244.537 99.2752 244.078 99.0881 243.759 98.9493C243.601 98.88 243.478 98.8232 243.398 98.7851C243.357 98.766 243.328 98.7517 243.31 98.7428L243.291 98.7336L243.291 98.7333C243.291 98.7332 243.291 98.7332 243.29 98.7331L243.29 98.7329C243.29 98.7328 243.29 98.7327 243.289 98.7326C243.289 98.7326 243.289 98.7326 243.289 98.7325C243.289 98.7325 243.289 98.7325 243.289 98.7325C243.003 98.5871 242.677 98.5376 242.36 98.5914C238.53 99.2409 234.596 95.9482 234.28 91.8705C234.128 89.9164 233.912 87.6343 233.608 84.99C233.089 80.4893 232.438 76.0099 231.822 72.1474C231.075 67.4607 235.025 63.3143 239.665 63.909C240.809 64.0556 241.905 63.7303 242.783 63.1616C244.166 62.2661 246.657 60.9348 249.001 60.9348C251.341 60.9348 253.829 62.2623 255.213 63.1582C256.095 63.7287 257.196 64.0553 258.344 63.9081C263.002 63.311 266.925 67.4463 266.123 72.1133C265.356 76.5797 264.57 81.4839 264.166 84.9948C263.879 87.4862 263.702 89.9834 263.596 92.2561C263.408 96.2667 259.807 99.2977 255.986 98.6497L255.642 98.5914Z",
    fill: "#F5CC00",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-52-inside-4_140_5929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.739,
    cy: 74.6957,
    rx: 3.13043,
    ry: 1.95652
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.739,
    cy: 74.6957,
    rx: 3.13043,
    ry: 1.95652,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.869 74.6957C242.869 74.2897 243.007 73.9705 243.139 73.7758C243.201 73.6835 243.259 73.6226 243.297 73.5874C243.336 73.5521 243.36 73.5367 243.362 73.5351C243.364 73.5341 243.311 73.5663 243.191 73.5981C243.074 73.6289 242.92 73.6522 242.739 73.6522V79.6522C244.076 79.6522 245.428 79.3195 246.542 78.6231C247.614 77.9532 248.869 76.6436 248.869 74.6957H242.869ZM242.739 73.6522C242.557 73.6522 242.404 73.6289 242.287 73.5981C242.167 73.5663 242.114 73.5341 242.115 73.5351C242.118 73.5367 242.142 73.5521 242.18 73.5874C242.218 73.6226 242.276 73.6835 242.339 73.7758C242.471 73.9705 242.608 74.2897 242.608 74.6957H236.608C236.608 76.6436 237.863 77.9532 238.935 78.6231C240.05 79.3195 241.402 79.6522 242.739 79.6522V73.6522ZM242.608 74.6957C242.608 75.1017 242.471 75.4208 242.339 75.6155C242.276 75.7078 242.218 75.7687 242.18 75.8039C242.142 75.8392 242.118 75.8546 242.115 75.8562C242.114 75.8572 242.167 75.825 242.287 75.7933C242.404 75.7625 242.557 75.7391 242.739 75.7391V69.7391C241.402 69.7391 240.05 70.0718 238.935 70.7682C237.863 71.4381 236.608 72.7478 236.608 74.6957H242.608ZM242.739 75.7391C242.92 75.7391 243.074 75.7625 243.191 75.7933C243.311 75.825 243.364 75.8572 243.362 75.8562C243.36 75.8546 243.336 75.8392 243.297 75.8039C243.259 75.7687 243.201 75.7078 243.139 75.6155C243.007 75.4208 242.869 75.1017 242.869 74.6957H248.869C248.869 72.7478 247.614 71.4381 246.542 70.7682C245.428 70.0718 244.076 69.7391 242.739 69.7391V75.7391Z",
    fill: "#262222",
    mask: "url(#path-52-inside-4_140_5929)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-54-inside-5_140_5929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.261,
    cy: 74.6957,
    rx: 3.13043,
    ry: 1.95652
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.391 74.6957C255.391 74.2897 255.529 73.9705 255.66 73.7758C255.723 73.6835 255.781 73.6226 255.819 73.5874C255.857 73.5521 255.882 73.5367 255.884 73.5351C255.886 73.5341 255.832 73.5663 255.712 73.5981C255.596 73.6289 255.442 73.6522 255.261 73.6522V79.6522C256.597 79.6522 257.95 79.3195 259.064 78.6231C260.136 77.9532 261.391 76.6436 261.391 74.6957H255.391ZM255.261 73.6522C255.079 73.6522 254.925 73.6289 254.809 73.5981C254.689 73.5663 254.635 73.5341 254.637 73.5351C254.64 73.5367 254.664 73.5521 254.702 73.5874C254.74 73.6226 254.798 73.6835 254.861 73.7758C254.992 73.9705 255.13 74.2897 255.13 74.6957H249.13C249.13 76.6436 250.385 77.9532 251.457 78.6231C252.571 79.3195 253.924 79.6522 255.261 79.6522V73.6522ZM255.13 74.6957C255.13 75.1017 254.992 75.4208 254.861 75.6155C254.798 75.7078 254.74 75.7687 254.702 75.8039C254.664 75.8392 254.64 75.8546 254.637 75.8562C254.635 75.8572 254.689 75.825 254.809 75.7933C254.925 75.7625 255.079 75.7391 255.261 75.7391V69.7391C253.924 69.7391 252.571 70.0718 251.457 70.7682C250.385 71.4381 249.13 72.7478 249.13 74.6957H255.13ZM255.261 75.7391C255.442 75.7391 255.596 75.7625 255.712 75.7933C255.832 75.825 255.886 75.8572 255.884 75.8562C255.882 75.8546 255.857 75.8392 255.819 75.8039C255.781 75.7687 255.723 75.7078 255.66 75.6155C255.529 75.4208 255.391 75.1017 255.391 74.6957H261.391C261.391 72.7478 260.136 71.4381 259.064 70.7682C257.95 70.0718 256.597 69.7391 255.261 69.7391V75.7391Z",
    fill: "#262222",
    mask: "url(#path-54-inside-5_140_5929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.043 84.4783C256.043 84.4783 253.293 87.5961 249 87.6087C244.777 87.6087 241.956 84.4783 241.956 84.4783",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 61C249 61 243.049 61 240 67",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 61C249 61 254.95 61 258 67",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.826 99.4663C253.826 99.4663 256.146 98.1391 256.695 95.9181",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.174 99.4663C244.174 99.4663 241.853 98.1391 241.304 95.9181",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.286 83.2421V83.2421C242.28 84.3971 241.346 85.3324 240.191 85.3395L240.141 85.3398",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.714 83.2421V83.2421C255.72 84.3971 256.654 85.3324 257.809 85.3395L257.859 85.3398",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.988 59.5C247.988 59.4998 247.988 59.4995 247.989 59.4992C248.196 59.1504 248.312 58.724 248.385 58.4202C248.468 58.0703 248.539 57.6708 248.599 57.2682C248.721 56.4602 248.814 55.5491 248.879 54.8118C248.883 54.7699 248.901 54.7341 248.93 54.708C248.956 54.6829 248.984 54.674 249.011 54.674C249.061 54.674 249.131 54.7177 249.14 54.8068C249.215 55.5453 249.32 56.4616 249.45 57.2731C249.514 57.6775 249.589 58.0774 249.674 58.4262C249.747 58.7285 249.864 59.1513 250.066 59.4945C250.067 59.4964 250.069 59.4982 250.07 59.5H247.988Z",
    fill: "#262222",
    stroke: "#262222",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.965 178.534L284.114 171.87H295.885L297.034 178.534C297.532 181.426 294.814 183.831 292.005 182.984C290.697 182.59 289.302 182.59 287.995 182.984C285.185 183.831 282.467 181.426 282.965 178.534Z",
    fill: "#D99C36",
    stroke: "#262222",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 140.674C297.046 140.674 302.542 144.034 306.315 148.629C310.114 153.256 312.087 159.048 312.087 163.667C312.087 166.105 311.906 168.18 311.638 169.915C311.364 171.694 310.321 172.868 308.835 173.529C307.299 174.213 305.27 174.34 303.238 173.828C299.668 172.929 295.107 172.15 290 172.15C284.893 172.15 280.331 172.929 276.762 173.828C274.73 174.34 272.701 174.213 271.164 173.529C269.679 172.868 268.636 171.694 268.362 169.915C268.094 168.18 267.913 166.105 267.913 163.667C267.913 159.048 269.885 153.256 273.685 148.629C277.457 144.034 282.953 140.674 290 140.674Z",
    fill: "#D99C36",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-66-inside-6_140_5929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.437,
    cy: 156.214,
    rx: 3.64583,
    ry: 1.50517,
    transform: "rotate(-10 283.437 156.214)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.437,
    cy: 156.214,
    rx: 3.64583,
    ry: 1.50517,
    transform: "rotate(-10 283.437 156.214)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.073 156.101C283.926 155.267 284.256 154.672 284.411 154.457C284.557 154.253 284.657 154.215 284.552 154.282C284.355 154.407 283.88 154.618 283.178 154.741L284.22 160.65C285.501 160.424 286.762 159.987 287.77 159.346C288.268 159.03 288.836 158.58 289.284 157.958C289.739 157.324 290.201 156.303 289.982 155.06L284.073 156.101ZM283.178 154.741C282.476 154.865 281.957 154.83 281.729 154.78C281.608 154.753 281.714 154.754 281.922 154.896C282.14 155.045 282.654 155.491 282.801 156.326L276.892 157.368C277.112 158.611 277.895 159.412 278.54 159.852C279.173 160.284 279.861 160.512 280.437 160.639C281.604 160.896 282.939 160.876 284.22 160.65L283.178 154.741ZM282.801 156.326C282.948 157.16 282.618 157.755 282.464 157.97C282.317 158.174 282.218 158.212 282.323 158.145C282.519 158.02 282.995 157.809 283.697 157.686L282.655 151.777C281.374 152.003 280.113 152.44 279.105 153.081C278.607 153.397 278.038 153.847 277.591 154.47C277.136 155.103 276.673 156.124 276.892 157.368L282.801 156.326ZM283.697 157.686C284.399 157.562 284.918 157.597 285.145 157.647C285.267 157.674 285.16 157.673 284.953 157.531C284.734 157.382 284.22 156.936 284.073 156.101L289.982 155.06C289.763 153.816 288.979 153.015 288.335 152.575C287.701 152.143 287.013 151.915 286.437 151.788C285.271 151.531 283.936 151.551 282.655 151.777L283.697 157.686Z",
    fill: "#262222",
    mask: "url(#path-66-inside-6_140_5929)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-68-inside-7_140_5929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.562,
    cy: 156.214,
    rx: 3.64583,
    ry: 1.50517,
    transform: "rotate(10 296.562 156.214)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.198 156.326C297.345 155.491 297.859 155.045 298.078 154.896C298.285 154.754 298.391 154.753 298.27 154.78C298.043 154.83 297.524 154.865 296.822 154.741L295.78 160.65C297.061 160.876 298.396 160.896 299.562 160.639C300.138 160.512 300.826 160.284 301.46 159.852C302.104 159.412 302.888 158.611 303.107 157.368L297.198 156.326ZM296.822 154.741C296.12 154.618 295.644 154.407 295.448 154.282C295.343 154.215 295.442 154.253 295.589 154.457C295.743 154.672 296.073 155.267 295.926 156.101L290.017 155.06C289.798 156.303 290.261 157.324 290.716 157.958C291.163 158.58 291.732 159.03 292.23 159.346C293.238 159.987 294.499 160.424 295.78 160.65L296.822 154.741ZM295.926 156.101C295.779 156.936 295.265 157.382 295.047 157.531C294.839 157.673 294.733 157.674 294.854 157.647C295.082 157.597 295.601 157.562 296.303 157.686L297.345 151.777C296.063 151.551 294.729 151.531 293.562 151.788C292.986 151.915 292.298 152.143 291.665 152.575C291.02 153.015 290.237 153.816 290.017 155.06L295.926 156.101ZM296.303 157.686C297.005 157.809 297.48 158.02 297.677 158.145C297.782 158.212 297.682 158.174 297.536 157.97C297.381 157.755 297.051 157.16 297.198 156.326L303.107 157.368C303.326 156.124 302.864 155.103 302.409 154.47C301.961 153.847 301.393 153.397 300.895 153.081C299.887 152.44 298.626 152.003 297.345 151.777L296.303 157.686Z",
    fill: "#262222",
    mask: "url(#path-68-inside-7_140_5929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.292 162C297.292 162 294.445 164.899 290 164.917C285.628 164.917 282.708 162 282.708 162",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.234 232.228C280.306 231.14 281.246 229.93 282.034 228.622L285.602 222.702C285.766 222.43 286.162 222.434 286.32 222.71L289.562 228.359C290.41 229.836 291.45 231.194 292.657 232.397C302.159 241.866 307.5 254.73 307.5 268.145V268.834C307.5 270.149 306.982 271.353 306.057 272.149C304.221 273.726 301.213 276.083 297.631 278.039C294.032 280.005 289.971 281.5 286 281.5C282.037 281.5 277.984 280.011 274.39 278.051C270.813 276.1 267.807 273.748 265.965 272.168C265.025 271.361 264.5 270.138 264.5 268.804V268.175C264.5 254.722 269.792 241.81 279.234 232.228Z",
    fill: "#4BAD4F",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 266C296 266 292.096 271.976 286 272C280.004 272 276 266 276 266",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.5 256C280.5 258.263 279.085 259.5 278 259.5C276.914 259.5 275.5 258.263 275.5 256C275.5 253.737 276.914 252.5 278 252.5C279.085 252.5 280.5 253.737 280.5 256Z",
    fill: "#262222",
    stroke: "#262222",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.5 256C296.5 258.263 295.085 259.5 294 259.5C292.914 259.5 291.5 258.263 291.5 256C291.5 253.737 292.914 252.5 294 252.5C295.085 252.5 296.5 253.737 296.5 256Z",
    fill: "#262222",
    stroke: "#262222",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.167 282H289.833L288.316 289.125C288.083 290.219 287.117 291 286 291C284.882 291 283.917 290.219 283.684 289.125L282.167 282Z",
    fill: "#262222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 225.375L286 245.002",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 237L280.995 241",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.995 237L291 241",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_5929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332,
    height: 310,
    fill: "white",
    transform: "translate(-0.000244141)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFinishTrainingGuide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FinishTrainingGuide.5bff0559fd4593f95301d02bb4d404a3.svg";